import { useStorage } from '@/hooks/web/useStorage'

/**
 * Cookie 设置的可选配置项接口
 */
export interface CookieOptions {
  days?: number // 有效期天数
  path?: string // 路径，默认为 '/'
  domain?: boolean // 域名
  // secure?: boolean // 是否仅通过 HTTPS 传输
  // sameSite?: 'Strict' | 'Lax' | 'None' // 跨域策略
}

/**
 * 设置 Cookie
 * @param name - Cookie 名称
 * @param value - Cookie 值
 * @param options - 配置项 (可选)
 */
export function setCookie(name: string, value: string, options: CookieOptions = {}): void {
  const { setStorage } = useStorage('sessionStorage')
  const hostname = window.location.hostname

  setStorage('token', value)

  // 对名称和值进行编码，防止特殊字符导致错误
  let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`

  const { days, path = '/' } = options

  // 处理过期时间
  if (typeof days === 'number') {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    cookieStr += `; expires=${date.toUTCString()}`
  }

  // 设置路径 (默认根路径)
  cookieStr += `; path=${path}`

  // 设置域名
  if (hostname.includes('wotels.com.cn')) {
    cookieStr += `; domain=.wotels.com.cn`
  } else {
    cookieStr += `; domain=${hostname}`
  }

  // 设置 Secure (仅在 HTTPS 下有效)
  if (hostname.includes('wotels.com.cn')) {
    cookieStr += '; secure'
  }

  // 设置 SameSite (防止 CSRF 攻击)
  if (hostname.includes('wotels.com.cn')) {
    cookieStr += `; samesite=None`
  }
  console.log(cookieStr)
  document.cookie = cookieStr
}
